import React from 'react'
import ReactHtmlParser from "react-html-parser";
import RfqInformation from './RfqInformation';


const MaterialMobileReadOnly = ({ values, setFieldValue, currentStep,
    steps,
    openAccordian,
    toggleAccordion,
    handleDownloadMaterialExcel,
    rfqData,
    toggleExpanded,
    expandedStates,
    overallTotal,
    overallTotalExclGST,
    visibleMiscellaneousItems,
    attachmentsData,
    togglePopup,
    isPopupOpen,
    isAdvancedTransport
}) => {
    return (
        <div className="block lg:hidden h-screen flex-grow overflow-auto">
            {/* Stepper */}
            {currentStep === 0 ? " " : (
                <div className="sticky top-0 z-20 shadow-md bg-white flex justify-center items-center px-10 py-3 w-full lg:hidden">
                    {/* Step 1 */}
                    <div className={`h-[30px] w-[30px] rounded-full flex justify-center items-center ${currentStep > 0 ? 'bg-[#313119]' : 'bg-[#DCDCDC]'}`}>
                        <p className={`text-xs font-medium ${currentStep > 0 ? 'text-white' : '#313119'}`}>1</p>
                    </div>
                    <div className={`flex-grow h-[2px] ${currentStep > 1 ? 'bg-[#313119]' : 'bg-[#DCDCDC]'} mx-2`}></div>

                    {/* Step 2 */}
                    <div className={`h-[30px] w-[30px] rounded-full flex justify-center items-center ${currentStep > 1 ? 'bg-[#313119]' : 'bg-[#DCDCDC]'}`}>
                        <p className={`text-xs font-medium ${currentStep > 1 ? 'text-white' : '#313119'}`}>2</p>
                    </div>
                    <div className={`flex-grow h-[2px] ${currentStep > 2 ? 'bg-[#313119]' : 'bg-[#DCDCDC]'} mx-2`}></div>

                    {/* Step 3 */}
                    <div className={`h-[30px] w-[30px] rounded-full flex justify-center items-center ${currentStep > 2 ? 'bg-[#313119]' : 'bg-[#DCDCDC]'}`}>
                        <p className={`text-xs font-medium ${currentStep > 2 ? 'text-white' : '#313119'}`}>3</p>
                    </div>
                    <div className={`flex-grow h-[2px] ${currentStep > 3 ? 'bg-[#313119]' : 'bg-[#DCDCDC]'} mx-2`}></div>

                    {/* Step 4 */}
                    <div className={`h-[30px] w-[30px] rounded-full flex justify-center items-center ${currentStep > 3 ? 'bg-[#313119]' : 'bg-[#DCDCDC]'}`}>
                        <p className={`text-xs font-medium ${currentStep > 3 ? 'text-white' : '#313119'}`}>4</p>
                    </div>
                </div>
            )}

            {/* stepper content */}
            <div className="h-auto flex-grow overflow-y-auto">
                <div className="flex justify-between">
                    {steps.map((step, index) => (
                        <div key={index} className={`step ${currentStep === index ? 'active' : ''}`}>
                            {/* {step} */}
                        </div>
                    ))}
                </div>

                <div className="relative step-content">
                    {currentStep === 0 && (
                        <div>
                            {/* Header Section */}
                            <div className=" lg:grid lg:grid-cols-2 flex items-center flex-col-reverse lg:px-8 lg:py-4 shadow-md sticky top-0 bg-white z-10">
                                <div >
                                    <div className="lg:flex items-center hidden  ">
                                        <h1 className="text-[28px] text-[#434343] font-semibold ">Add Proposal: Rs. {overallTotal.toFixed(2)}</h1>
                                        <span className="text-sm bg-[#E9E9E9] ml-4 px-4 py-2 text-[#434343]">Draft</span>
                                    </div>
                                </div>
                            </div>
                            <div className="p-4 sticky top-0 flex items-center justify-center shadow-md">
                                <div >
                                    {/* <div className="flex items-center space-x-2">
                                        <span class="relative flex items-center justify-center h-4 w-4 ">
                                            <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-lime-500 opacity-40"></span>
                                            <span class="relative inline-flex rounded-full h-2 w-2 bg-lime-500"></span>
                                        </span>
                                        <h3 className="text-sm lg:mt-1 text-center text-[#737373]">
                                            Quotation Rank:{" "}
                                            <span className="font-bold text-black">
                                                {currentRank === "L1"
                                                    ? "L2"
                                                    : currentRank === undefined || currentRank === null
                                                        ? "Quotation not submitted"
                                                        : currentRank}
                                            </span>
                                        </h3>
                                        <p className="text-[#9F9F9F] lg:mt-1 text-xs italic hidden lg:block">Your rank will update as soon as the buyer receives atleast 3 ratings</p>
                                    </div> */}
                                </div>
                            </div>
                            {/* rfq information */}
                            <div className="">
                                <div className="px-4 lg:py-[24px] lg:px-8 mt-4 mb-1 lg:hidden">
                                    {/* <h3 className="text-xl font-semibold text-[#3B3B3B]">{rfqData?.name}</h3> */}
                                    <h3 className="text-sm font-semibold text-[#3B3B3B]"><span className="text-[#787878]">Requirement Name:</span> {rfqData?.name}</h3>
                                    {/* <img src="https://storagereponeevaydevcdn.blob.core.windows.net/business/Bookmark.svg" alt="save" className="self-start" /> */}

                                    <p className="text-sm font-normal text-[#787878] lg:hidden">Create Date: {new Date(rfqData?.createdAt).toLocaleDateString('en-GB')}</p>
                                    <p className="text-sm font-medium text-[#787878] mt-2 lg:hidden">RFQ Information</p>
                                </div>
                                <RfqInformation
                                    rfqData={rfqData}
                                    togglePopup={togglePopup}
                                    isPopupOpen={isPopupOpen}
                                />
                            </div>

                            {
                                <div className="flex flex-col items-end m-6">
                                    <div className="flex space-x-4">
                                        <button
                                            type="button"
                                            onClick={handleDownloadMaterialExcel}
                                            className="bg-blue-500 text-white px-3 py-1.5 text-xs"
                                        >
                                            Download Requirement
                                        </button>

                                        {/* <label className="border border-gray-800 px-3 py-1.5 cursor-pointer text-xs">
                                            Upload Rates
                                            <input
                                                type="file"
                                                accept=".xlsx"
                                                onChange={(e) => handleUploadMaterialExcel(e, setFieldValue, values)}
                                                className="hidden"
                                            />
                                        </label> */}
                                    </div>
                                    <p className="text-xs text-gray-500 mt-2">Note: Download requirement for uploading material list</p>
                                </div>
                            }


                        </div>
                    )}
                    <div className="px-4 py-6">
                        {currentStep === 1 && (
                            <div>
                                {/* input fields */}
                                <div>
                                    <h3 className="text-sm font-semibold text-[#3B3B3B] lg:hidden">Material List</h3>
                                    <p className="text-xs font-normal text-[#9D9D9D] lg:hidden">Add quotations for the Material List below</p>

                                    <div className="space-y-2 mt-4 mb-8">
                                        {rfqData?.materials?.map((row, index) => (
                                            <div key={index}>
                                                {/* Mobile Accordion Header */}
                                                <div className={`block lg:hidden border shadow-md py-4 px-4 cursor-pointer ${openAccordian === index ? 'shadow-none' : ''}`} onClick={() => toggleAccordion(index)}>
                                                    <div className="flex justify-between items-center">
                                                        <div className="flex justify-start items-center space-x-4">
                                                            <div className="w-[24px] h-[24px] bg-[#EFEFEB] rounded-full flex justify-center items-center">
                                                                <p className="text-xs text-[#6A6A6A]">{index + 1}</p>
                                                            </div>
                                                            <h2 className="text-sm font-semibold">{ReactHtmlParser(row?.name)}</h2>
                                                        </div>
                                                        <div className="flex justify-end space-x-4">
                                                            {/* <img src="https://storagereponeevaydevcdn.blob.core.windows.net/business/tick_vendor_quotation.svg" alt="tick" /> */}
                                                            <img
                                                                src="https://storagereponeevaydevcdn.blob.core.windows.net/business/dropdown_arrow.svg"
                                                                alt=""
                                                                className={`ml-2 transition-transform ${openAccordian === index ? 'rotate-180' : ''}`}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Accordion Content */}
                                                {openAccordian === index && (
                                                    <div className="space-y-4 py-4 px-4 shadow-md border border-t-transparent">

                                                        {/* quantity */}
                                                        <div className="self-end">
                                                            <label htmlFor="" className="text-sm pb-2 font-semibold lg:hidden">Brand</label>
                                                            <p className="text-sm col-span-1">{row.brands.join(", ")}</p>
                                                        </div>

                                                        {/* quantity */}
                                                        <div className="self-end">
                                                            <label htmlFor="" className="text-sm pb-2 font-semibold lg:hidden">Quantity</label>
                                                            <p className="text-sm col-span-1">{row.quantity} {row.unit}</p>
                                                        </div>

                                                        {/* specifications */}
                                                        {row?.specifications?.length > 0 && <div className="self-end col-span-2">
                                                            <label htmlFor="" className="text-sm font-semibold pb-2 lg:hidden">Specifications</label>
                                                            <div className="col-span-6 min-h-fit">
                                                                {row?.specifications?.length > 0 && (
                                                                    <div className="col-span-4 text-xs">
                                                                        <p className="font-light whitespace-pre-line">
                                                                            {ReactHtmlParser(
                                                                                expandedStates[index]
                                                                                    ? row?.specifications
                                                                                    : row?.specifications?.substring(0, 160) +
                                                                                    (row?.specifications?.length > 160
                                                                                        ? "..."
                                                                                        : "")
                                                                            )}
                                                                        </p>
                                                                        {row?.specifications?.length > 160 && (
                                                                            <button
                                                                                type="button"
                                                                                className="text-[#8E8E85] text-xs underline italic"
                                                                                onClick={() => toggleExpanded(index)}
                                                                            >
                                                                                {expandedStates[index] ? "Read Less" : "Read More"}
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>}

                                                        {/* mrp */}
                                                        <div className="col-span-2 flex flex-col">
                                                            <label className="font-semibold text-sm col-span-2 flex items-center relative">
                                                                MRP Per Unit
                                                                <span className="bg-[#cac9c9] text-white text-xs h-[15px] w-[15px] flex justify-center items-center mb-1 ml-1 pt-1 rounded-full lowercase relative group hover:cursor-pointer">
                                                                    i
                                                                    <span className="absolute bottom-[130%] text-xs left-1/2 w-[200px] z-10 transform -translate-x-1/2 px-2 py-1 text-[#434343] text-left bg-white border border-gray-300 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                                                                        Enter the cost per unit for the selected construction material. Ensure accuracy as this value impacts overall project budgeting and pricing.
                                                                    </span>
                                                                </span>
                                                            </label>

                                                            {/* Displaying the value as plain text instead of an input field */}
                                                            <p className="lg:w-full w-[220px] text-sm flex items-center">
                                                                {values.materials[index]?.basePrice || "N/A"}
                                                            </p>
                                                        </div>

                                                        <div className="flex space-x-8 items-center">
                                                            {/* Discount */}
                                                            <div className="col-span-2 self-start flex flex-col">
                                                                <label className="font-semibold text-sm col-span-2 flex items-center relative">
                                                                    Discount (%)
                                                                    <span className="bg-[#cac9c9] text-white text-xs h-[15px] w-[15px] flex justify-center items-center mb-1 ml-1 pt-1 rounded-full lowercase relative group hover:cursor-pointer">
                                                                        i
                                                                        <span className="absolute bottom-[130%] text-xs left-1/2 w-[200px] z-10 transform -translate-x-1/2 text-[#434343] text-left bg-white border border-gray-300 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                                                                            Specify the discount percentage or amount offered on this material. This discount will be applied to the unit cost and reflected in the final pricing.
                                                                        </span>
                                                                    </span>
                                                                </label>
                                                                <p className="w-[100px] flex items-center">
                                                                    {values.materials[index]?.discount || "N/A"}
                                                                </p>
                                                            </div>

                                                            {/* GST */}
                                                            <div className="col-span-1 self-start w-1/4">
                                                                <label className="text-sm font-semibold lg:hidden">GST (%)</label>
                                                                <p className="text-base flex items-center">
                                                                    {values.materials[index]?.gst || "N/A"}
                                                                </p>
                                                            </div>
                                                        </div>


                                                        <div className="col-span-2 flex flex-col">
                                                            <label className="font-semibold text-sm col-span-2 flex items-center relative">
                                                                Item Rate
                                                            </label>
                                                            <p className=" col-span-3 text-base">{new Intl.NumberFormat('en-IN').format(values.materials[index].basePrice - (values.materials[index].basePrice * values.materials[index].discount) / 100) || 0}</p>
                                                        </div>

                                                        {isAdvancedTransport && (
                                                            <div className="col-span-2 flex flex-col">
                                                                <label className="font-semibold text-sm col-span-2 flex items-center relative">
                                                                    Transport Per Unit
                                                                </label>
                                                                <div className="col-span-2 justify-self-center flex flex-col">
                                                                    <p className="w-1/2 p-1 text-xs text-right h-[30px] flex items-center">
                                                                        {values.materials[index]?.transportRate || "N/A"}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        )}


                                                        <div className="flex justify-between w-full">
                                                            <label className="font-semibold text-sm col-span-2 flex items-center relative">
                                                                Transport Cost :
                                                            </label>
                                                            {isAdvancedTransport && (
                                                                <p className="pr-2 break-words">
                                                                    {new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(values.materials[index].transportCost || 0)}
                                                                </p>
                                                            )}
                                                        </div>

                                                        <div className="flex justify-start space-x-4 items-center text-center col-span-1 mt-2">
                                                            <p className="text-sm font-semibold">Attachments</p>
                                                            <div className="relative">
                                                                {values.materials[index]?.attachments?.length > 0 ? (
                                                                    <p className="text-sm text-gray-700">
                                                                        {values.materials[index].attachments.length} file(s) attached
                                                                    </p>
                                                                ) : (
                                                                    <p className="text-sm text-gray-500 italic">No attachments</p>
                                                                )}
                                                            </div>
                                                        </div>

                                                        {values?.materials?.[index]?.remark?.length > 0 && <div className="self-end col-span-2">
                                                            <label htmlFor="" className="text-sm font-semibold pb-2 lg:hidden">Remarks</label>
                                                            <div className="col-span-6 min-h-fit">
                                                                {values?.materials?.[index]?.remark?.length > 0 && (
                                                                    <div className="col-span-4 text-xs">
                                                                        <p className="font-light whitespace-pre-line">
                                                                            {ReactHtmlParser(
                                                                                expandedStates[index]
                                                                                    ? values?.materials?.[index]?.remark
                                                                                    : values?.materials?.[index]?.remark?.substring(0, 160) +
                                                                                    (values?.materials?.[index]?.remark?.length > 160
                                                                                        ? "..."
                                                                                        : "")
                                                                            )}
                                                                        </p>
                                                                        {values?.materials?.[index]?.remark?.length > 160 && (
                                                                            <button
                                                                                type="button"
                                                                                className="text-[#8E8E85] text-xs underline italic"
                                                                                onClick={() => toggleExpanded(index)}
                                                                            >
                                                                                {expandedStates[index] ? "Read Less" : "Read More"}
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>}


                                                        {/* amount */}
                                                        <div className="w-full py-2 px-4 flex justify-between items-center bg-[#E7EAEF] border-t-[#004491] lg:bg-white lg:border-none">
                                                            <label htmlFor="" className="text-base text-[#004491] font-semibold lg:hidden">Total (Excl. GST)</label>
                                                            <p className="text-right text-sm self-end text-[#004491] lg:text-black col-span-1">Rs. {new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(values.materials[index].totalExclGst || 0)}</p>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}
                        {currentStep === 2 && (
                            <div>
                                {/* miscellaneous */}
                                <div>
                                    <h3 className="text-sm font-semibold text-[#3B3B3B] lg:hidden">Other Charges</h3>
                                    <p className="text-xs font-normal text-[#9D9D9D] pb-4 lg:hidden">Please indicate any miscellaneous charges that will be incurred</p>
                                    <div className="border lg:border-none shadow-md px-3 pb-3 pt-4 space-y-4 lg:space-y-2">
                                        {/* Mapping miscellaneousItems instead of charges */}
                                        {visibleMiscellaneousItems.map((item, index) => (
                                            <div key={index}>
                                                {/* MRP and GST inputs for mobile */}
                                                <div className="flex justify-between lg:hidden pb-2">
                                                    <div>
                                                        <p className="text-sm">{item.label}</p>
                                                        {isAdvancedTransport && item.name === "transport" && (
                                                            <p className="text-xs font-normal text-[#9D9D9D] pb-4 lg:hidden">
                                                                Transport cost based on the per-unit material transport rate
                                                            </p>
                                                        )}

                                                        {/* Display MRP as plain text */}
                                                        <p className="w-[120px] flex items-center text-sm">
                                                            Rs.{values?.miscellaneousCosts?.[item.name]?.mrp || "0"}
                                                        </p>
                                                    </div>

                                                    <div>
                                                        <p className="text-sm">GST</p>

                                                        {/* Display GST as plain text */}
                                                        <p className="col-span-1 w-[64px] flex items-center text-sm">
                                                            {values?.miscellaneousCosts?.[item.name]?.gst ?? "N/A"}
                                                        </p>
                                                    </div>
                                                </div>


                                                {/* Subtotal display */}
                                                <div className="flex justify-between lg:justify-end items-center py-2 px-3 bg-[#E7EAEF] border border-t-[#004491] lg:border-none lg:bg-white">
                                                    <p className="text-[#004491] text-sm font-semibold lg:hidden">Total</p>
                                                    <p className="text-[#004491] font-semibold lg:font-normal col-span-1 lg:text-black lg:text-right">
                                                        Rs. {values.miscellaneousCosts[item.name].mrp || 0}
                                                    </p>
                                                </div>
                                            </div>
                                        ))}

                                        {/* Total amount for mobile */}
                                        <div className="lg:hidden">
                                            <div className="flex px-4 py-2 lg:p-0 justify-between items-center border lg:border-none border-t-[#007366] lg:bg-white">
                                                <p className="lg:font-bold text-[#007366] lg:text-black font-semibold">Sub Total</p>
                                                <p className="text-[#007366] font-semibold text-end lg:font-normal lg:text-black w-fit min-w-[164px] lg:px-4 py-2">
                                                    Rs. {overallTotalExclGST || 0}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="lg:hidden">
                                            <div className="flex px-4 py-2 lg:p-0 justify-between items-center border lg:border-none border-t-[#007366] lg:bg-white">
                                                <p className="lg:font-bold text-[#007366] lg:text-black font-semibold">GST Total</p>
                                                <p className="text-[#007366] font-semibold text-end lg:font-normal lg:text-black w-fit min-w-[164px] lg:px-4 py-2">
                                                    Rs. {new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format((overallTotal - overallTotalExclGST).toFixed(2))}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="lg:hidden">
                                            <div className="flex px-4 py-2 lg:p-0 justify-between items-center border lg:border-none border-t-[#007366] bg-[#E0F0EE] lg:bg-white">
                                                <p className="lg:font-bold text-[#007366] lg:text-black font-semibold">Total Quotation Value (inc. GST)</p>
                                                <p className="bg-[#E0F0EE] text-[#007366] font-semibold text-end lg:font-normal lg:text-black w-fit min-w-[164px] lg:px-4 py-2">
                                                    Rs. {overallTotal || 0}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {currentStep === 3 && (
                            <div>
                                {/* Supporting Documents Section */}
                                <div className="mb-8 lg:mb-[40px]">
                                    <h3 className="text-sm font-semibold text-[#3B3B3B] lg:hidden">Supporting Documents</h3>
                                    <p className="text-xs font-normal text-[#9D9D9D] pb-4 lg:hidden">
                                        Below are the supporting documents uploaded by the buyer. Please review them.
                                    </p>

                                    {attachmentsData.length > 0 ? (
                                        <div className="lg:grid lg:grid-cols-4 lg:gap-4 space-y-4 lg:space-y-0 lg:mt-4">
                                            {attachmentsData.map((doc, index) => (
                                                <div key={index} className="flex justify-between items-center">
                                                    <div className="flex w-fit items-center justify-center border border-[#8E8E85] rounded-full py-2 px-2 space-x-2 text-[#434343] bg-gray-100">
                                                        {/* Dynamic icon based on file type */}
                                                        <img src={`/assets/icons/${doc.Path}.png`} alt={doc.Path} className="h-5 w-5" />
                                                        {/* Document name (non-clickable) */}
                                                        <p className="text-xs text-[#434343]">{doc.Name}</p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="text-gray-400 italic">
                                            No Supporting Documents provided by Buyer, move to next step.
                                        </div>
                                    )}
                                </div>

                            </div>
                        )}
                        {currentStep === 4 && (
                            <div>
                                {/* Additional Information Section */}
                                <div className="mb-8">
                                    <h3 className="text-xl lg:mx-0 font-semibold text-[#3B3B3B] lg:hidden">Additional Information</h3>
                                    <p className="text-sm font-normal lg:mx-0 py-4 lg:hidden">Below are our payment Terms.</p>

                                    <div className="lg:flex justify-between items-center">
                                        <div>
                                            <div className="">
                                                <p
                                                    className="w-full border-none p-2 bg-[#F6F6F4] text-sm"
                                                    dangerouslySetInnerHTML={{
                                                        __html: rfqData?.paymentTerms,
                                                    }}
                                                ></p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mt-4 lg:mt-8 lg:mx-0">
                                        <p className="text-[#434343] mb-2 lg:mb-0">Make/Brand & Remarks for Client</p>
                                        <p className="w-full lg:ml-5 lg:w-full placeholder:italic p-2 bg-[#F6F6F4]">
                                            {values.notes || "No remarks provided."}
                                        </p>
                                    </div>
                                </div>

                                {/* Upload Supporting Documents */}
                                <div className="mb-8">
                                    <h3 className="whitespace-nowrap text-[#434343] text-xl font-bold pb-4 lg:pb-0 lg:mt-[60px] lg:mb-[30px]">Supporting Documents</h3>

                                    {attachmentsData.length > 0 ? (
                                        <div className="lg:grid lg:grid-cols-4 lg:gap-4 space-y-4 lg:space-y-0 lg:mt-4">
                                            {attachmentsData.map((doc, index) => (
                                                <div key={index} className="flex items-center">
                                                    <div className="flex w-fit items-center justify-center border border-[#8E8E85] rounded-full py-2 px-2 space-x-2 text-[#434343] bg-gray-100">
                                                        <img src={`/assets/icons/${doc.Path}.png`} alt={doc.Path} className="h-5 w-5" />
                                                        <p className="text-xs text-[#434343]">{doc.Name}</p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="text-gray-400 italic">
                                            No Supporting Documents provided.
                                        </div>
                                    )}
                                </div>
                            </div>

                        )}

                        {currentStep === 5 &&

                            (<div className="text-gray-400 italic">No Supporting Documents provided by Buyer, move to next step </div>)

                        }
                    </div>
                </div>


            </div>
        </div>
    )
}

export default MaterialMobileReadOnly